export const journey4 = {
    id: 'journey-4',
    schemaVersion: 2,
    covers: 'One held statement over a long treatment run, building to a second line. Suits a single feeling or promise, not a list of points.',
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 655,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 6],
                    },
                    required: true,
                },
                fit: 'contain-blur',
                kenBurnsOnImages: true,
                cuts: {
                    mode: 'at',
                    at: [
                        {
                            atSec: 3.533,
                            transition: 'cut',
                        },
                        {
                            atSec: 7.3,
                            transition: 'cut',
                        },
                        {
                            atSec: 11,
                            transition: 'cut',
                        },
                        {
                            atSec: 14.733,
                            transition: 'cut',
                        },
                        {
                            atSec: 15.867,
                            transition: 'cut',
                        },
                        {
                            atSec: 17.733,
                            transition: 'fade',
                        },
                    ],
                },
                motion: {
                    tracks: [
                        {
                            channel: 'blur',
                            from: 0,
                            to: 12,
                            duration: 9,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 99,
                            },
                        },
                        {
                            channel: 'blur',
                            from: 12,
                            to: 0,
                            duration: 8,
                            easing: 'ease-out',
                            anchor: {
                                at: 'start',
                                frame: 107,
                            },
                        },
                        {
                            channel: 'brightness',
                            from: 1,
                            to: 0.4,
                            duration: 12,
                            easing: 'ease-in-out',
                            anchor: {
                                at: 'start',
                                frame: 446,
                            },
                        },
                        {
                            channel: 'brightness',
                            from: 0.4,
                            to: 0.5,
                            duration: 14,
                            easing: 'ease-in-out',
                            anchor: {
                                at: 'start',
                                frame: 546,
                            },
                        },
                    ],
                },
            },
        ],
        overlays: [
            {
                kind: 'group',
                id: 'flare-wash-a',
                start: {
                    at: 'frame',
                    value: 99,
                },
                duration: {
                    kind: 'fixed',
                    frames: 12,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'linear-gradient(90deg, #C63B00 0%, #B31700 45%, #9C0007 100%)',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                duration: 3,
                                easing: 'ease-out',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                duration: 5,
                                easing: 'linear',
                                anchor: {
                                    at: 'start',
                                    frame: 6,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'flare-wash-b',
                start: {
                    at: 'frame',
                    value: 104,
                },
                duration: {
                    kind: 'fixed',
                    frames: 12,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'linear-gradient(90deg, #B60000 0%, #D44600 50%, #E57200 100%)',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                duration: 5,
                                easing: 'linear',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                duration: 2,
                                easing: 'ease-out',
                                anchor: {
                                    at: 'start',
                                    frame: 9,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'leak-red-a',
                start: {
                    at: 'frame',
                    value: 446,
                },
                duration: {
                    kind: 'fixed',
                    frames: 46,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'linear-gradient(30deg, #120000 0%, #380200 45%, #7E0402 100%)',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.86,
                                duration: 10,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.86,
                                to: 0,
                                duration: 14,
                                easing: 'linear',
                                anchor: {
                                    at: 'start',
                                    frame: 32,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'leak-red-warm',
                start: {
                    at: 'frame',
                    value: 468,
                },
                duration: {
                    kind: 'fixed',
                    frames: 46,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'linear-gradient(30deg, #6E3A12 0%, #8C3A28 50%, #922B04 100%)',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.86,
                                duration: 14,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.86,
                                to: 0,
                                duration: 16,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 30,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'leak-red-b',
                start: {
                    at: 'frame',
                    value: 496,
                },
                duration: {
                    kind: 'fixed',
                    frames: 32,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'linear-gradient(210deg, #120000 0%, #2A0100 50%, #4C0100 100%)',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.86,
                                duration: 14,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.86,
                                to: 0,
                                duration: 12,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 20,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'leak-teal',
                start: {
                    at: 'frame',
                    value: 528,
                },
                duration: {
                    kind: 'fixed',
                    frames: 18,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'linear-gradient(90deg, #006269 0%, #5F9BA8 50%, #1F89BC 100%)',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.85,
                                duration: 8,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.85,
                                to: 0,
                                duration: 8,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 10,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'leak-violet',
                start: {
                    at: 'frame',
                    value: 536,
                },
                duration: {
                    kind: 'fixed',
                    frames: 22,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'linear-gradient(250deg, #1C2021 0%, #4A3AA0 55%, #2727A7 100%)',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.8,
                                duration: 8,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.8,
                                to: 0,
                                duration: 9,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 13,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'wash-blue',
                start: {
                    at: 'frame',
                    value: 546,
                },
                duration: {
                    kind: 'fixed',
                    frames: 109,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'linear-gradient(180deg, #0D1A66 0%, #060A3A 60%, #03051F 100%)',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.62,
                                duration: 16,
                                easing: 'ease-in-out',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'leak-violet-floor',
                start: {
                    at: 'frame',
                    value: 448,
                },
                duration: {
                    kind: 'fixed',
                    frames: 84,
                },
                placement: {
                    anchor: 'center',
                    x: 0.44,
                    y: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'radial-gradient(circle, rgba(92,14,214,0.85) 0%, rgba(92,14,214,0.72) 38%, rgba(92,14,214,0.46) 58%, rgba(92,14,214,0.2) 74%, rgba(92,14,214,0.06) 87%, rgba(92,14,214,0) 100%)',
                        width: 1320,
                        height: 1320,
                        radius: 660,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.85,
                                duration: 12,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.85,
                                to: 0,
                                duration: 16,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 66,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'bokeh-yellow',
                start: {
                    at: 'frame',
                    value: 516,
                },
                duration: {
                    kind: 'fixed',
                    frames: 26,
                },
                placement: {
                    anchor: 'center',
                    x: 0.45,
                    y: 0.29,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'radial-gradient(circle, rgba(232,196,82,0.85) 0%, rgba(232,196,82,0.72) 38%, rgba(232,196,82,0.46) 58%, rgba(232,196,82,0.2) 74%, rgba(232,196,82,0.06) 87%, rgba(232,196,82,0) 100%)',
                        width: 780,
                        height: 780,
                        radius: 390,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.72,
                                duration: 10,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.72,
                                to: 0,
                                duration: 12,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 14,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'bokeh-green',
                start: {
                    at: 'frame',
                    value: 518,
                },
                duration: {
                    kind: 'fixed',
                    frames: 26,
                },
                placement: {
                    anchor: 'center',
                    x: 0.24,
                    y: 0.43,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'radial-gradient(circle, rgba(127,165,60,0.85) 0%, rgba(127,165,60,0.72) 38%, rgba(127,165,60,0.46) 58%, rgba(127,165,60,0.2) 74%, rgba(127,165,60,0.06) 87%, rgba(127,165,60,0) 100%)',
                        width: 700,
                        height: 700,
                        radius: 350,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.68,
                                duration: 10,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.68,
                                to: 0,
                                duration: 12,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 14,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'bokeh-orange',
                start: {
                    at: 'frame',
                    value: 520,
                },
                duration: {
                    kind: 'fixed',
                    frames: 26,
                },
                placement: {
                    anchor: 'center',
                    x: 0.28,
                    y: 0.73,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'radial-gradient(circle, rgba(224,118,28,0.85) 0%, rgba(224,118,28,0.72) 38%, rgba(224,118,28,0.46) 58%, rgba(224,118,28,0.2) 74%, rgba(224,118,28,0.06) 87%, rgba(224,118,28,0) 100%)',
                        width: 740,
                        height: 740,
                        radius: 370,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.7,
                                duration: 10,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.7,
                                to: 0,
                                duration: 12,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 14,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'bokeh-pink',
                start: {
                    at: 'frame',
                    value: 522,
                },
                duration: {
                    kind: 'fixed',
                    frames: 26,
                },
                placement: {
                    anchor: 'center',
                    x: 0.73,
                    y: 0.55,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'radial-gradient(circle, rgba(209,74,122,0.85) 0%, rgba(209,74,122,0.72) 38%, rgba(209,74,122,0.46) 58%, rgba(209,74,122,0.2) 74%, rgba(209,74,122,0.06) 87%, rgba(209,74,122,0) 100%)',
                        width: 660,
                        height: 660,
                        radius: 330,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.66,
                                duration: 10,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.66,
                                to: 0,
                                duration: 12,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 14,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'bokeh-magenta',
                start: {
                    at: 'frame',
                    value: 524,
                },
                duration: {
                    kind: 'fixed',
                    frames: 26,
                },
                placement: {
                    anchor: 'center',
                    x: 0.56,
                    y: 0.88,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: 'radial-gradient(circle, rgba(163,24,106,0.85) 0%, rgba(163,24,106,0.72) 38%, rgba(163,24,106,0.46) 58%, rgba(163,24,106,0.2) 74%, rgba(163,24,106,0.06) 87%, rgba(163,24,106,0) 100%)',
                        width: 780,
                        height: 780,
                        radius: 390,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.68,
                                duration: 10,
                                easing: 'ease-in-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0.68,
                                to: 0,
                                duration: 12,
                                easing: 'ease-in-out',
                                anchor: {
                                    at: 'start',
                                    frame: 14,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'scene-0',
                duration: {
                    kind: 'fixed',
                    frames: 655,
                },
                start: {
                    at: 'frame',
                    value: 0,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.5,
                    y: 0.908,
                    width: 0.24,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'handle',
                            },
                            required: true,
                        },
                    },
                    style: 'display',
                    styleOverride: {
                        colorRole: 'onPrimary',
                        textTransform: 'none',
                        fontSize: 37.8,
                        fontWeight: 500,
                    },
                    align: 'center',
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                duration: 12,
                                easing: 'linear',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                duration: 35,
                                easing: 'linear',
                                anchor: {
                                    at: 'start',
                                    frame: 365,
                                },
                            },
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                duration: 24,
                                easing: 'linear',
                                anchor: {
                                    at: 'start',
                                    frame: 446,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'scene-1',
                duration: {
                    kind: 'fixed',
                    frames: 368,
                },
                start: {
                    at: 'frame',
                    value: 32,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.488,
                    width: 0.627,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'start',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 160,
                                fontWeight: 500,
                            },
                            entrance: 'typewriter',
                            entranceDurationFrames: 19,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'label',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 50,
                                fontWeight: 500,
                            },
                            motion: {
                                token: 'slide-up',
                                durationFrames: 14,
                                delayFrames: 35,
                            },
                            align: 'left',
                            container: {
                                paddingX: 12,
                            },
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                duration: 35,
                                easing: 'linear',
                                anchor: {
                                    at: 'end',
                                    frame: 35,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'scene-2',
                duration: {
                    kind: 'fixed',
                    frames: 105,
                },
                start: {
                    at: 'frame',
                    value: 550,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.477,
                    width: 0.472,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 66.3,
                                fontWeight: 500,
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 10,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'label2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 41.8,
                                fontWeight: 500,
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 10,
                            align: 'center',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'flare-bloom',
                start: {
                    at: 'frame',
                    value: 101,
                },
                duration: {
                    kind: 'fixed',
                    frames: 12,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: '#FBEFD0',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 0.88,
                                duration: 5,
                                easing: 'ease-in',
                            },
                            {
                                channel: 'opacity',
                                from: 0.88,
                                to: 0,
                                duration: 5,
                                easing: 'ease-out',
                                anchor: {
                                    at: 'start',
                                    frame: 6,
                                },
                            },
                        ],
                    },
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        handle: {
            type: 'text',
            maxChars: 23,
            description: "The clinic's social handle as it should read on screen, including the @. Held from the first frame, so it is the one piece of identification in an otherwise wordless opening.",
        },
        statement: {
            type: 'text',
            maxChars: 18,
            description: 'The treatment\'s NAME, set as a title card — the way it appears on the device or the price list, not a sentence about it. Two or three words, no verb, no full stop. Source shape: "EM SLIM".',
        },
        label: {
            type: 'text',
            maxChars: 20,
            description: 'What that treatment IS, in category terms, sitting under the name. A noun phrase, not a benefit. Source shape: "MUSCLE TONING".',
        },
        statement2: {
            type: 'text',
            maxChars: 25,
            description: 'The RESULT the client walks away with, as a title card in the same shape as `statement` — a noun phrase, not a sentence, and not a repeat of the treatment\'s name. Source shape: "Stronger Core".',
        },
        label2: {
            type: 'text',
            maxChars: 23,
            description: 'The category that result belongs to, under it, matching `label`\'s shape. Source shape: "Body Sculpting".',
        },
    },
    structure: 'A title card, then a closing card — NOT sentences. `statement` names the treatment the way it would appear on a device or a price list and `label` says what category it belongs to; near the end `statement2` and `label2` do the same for the RESULT the client walks away with. Four short noun phrases, no verbs, no punctuation. The source is: "EM SLIM / MUSCLE TONING" then "Stronger Core / Body Sculpting".',
};
//# sourceMappingURL=journey-4.js.map